export default __webpack_public_path__ + "static/banner_threed-689cc9062bb6b79d6d5a6a135388719f.webp";